import React from 'react';
import { IndicatorInfo } from './types';
import { Loading } from '../../design/loading/Loading';
import { SparkLine } from './spark';
import { ClickableCard } from '../../design/clickable.card/card';
import { useUiAction } from '../../ui.actions';
import { useAnalyticsContext } from '../../analytics/analytics.provider';
import { trackPageElementClicked } from '../../analytics/utils';
import { NBSP } from '../constants';
import classNames from 'classnames';
import { useMobile } from '../../context/mobile/mobile.provider';

type Props = {
  rowValue?: string;
  info?: IndicatorInfo;
  isLoading: boolean;
  isClickable?: boolean;
};
function IndicatorCard({ info, isLoading, rowValue, isClickable = true }: Props) {
  const { perform } = useUiAction();

  const { trackPageEvent } = useAnalyticsContext();

  const { isMobile } = useMobile();
  const handleClick = () => {
    if (!info?.clickAction) {
      return;
    }

    trackPageElementClicked(trackPageEvent, info.clickAction.tracking.eventName, info.clickAction.tracking);

    perform(info.clickAction.action, {
      column: [info.mainColumn.name],
      target: rowValue ? [rowValue] : [],
    });
  };
  return (
    <ClickableCard
      outerCss={isMobile ? 'indicator-card-mobile' : 'indicator-card'}
      innerCss={`${isLoading ? 'h-28' : ''}`}
      onClick={isClickable && info?.clickAction?.action && !isLoading ? handleClick : undefined}
      linkText={info?.clickAction?.label}
    >
      <Loading isActive={info === undefined || isLoading} withIndicator />
      <div className="flex items-stretch justify-between">
        {info?.mainColumn && (
          <div>
            <div
              className={classNames('', {
                'text-xs': isMobile,
                'text-md': !isMobile,
              })}
            >
              {info.mainColumn.label}
            </div>
            <div
              className={classNames('font-bold', {
                'text-xl': isMobile,
                'text-3xl': !isMobile,
              })}
            >
              {info.mainColumn.value}
            </div>
            <div
              className={classNames(`font-bold ${info.mainColumn.changeRaw < 0 ? 'text-ui-red' : 'text-ui-green'}`, {
                'text-xs': isMobile,
              })}
            >
              {info.mainColumn.changeValue ?? NBSP}
            </div>
          </div>
        )}
        {info?.secondaryColumn && (
          <div className="text-right">
            <div
              className={classNames('', {
                'text-xs': isMobile,
                'text-md': !isMobile,
              })}
            >
              {info.secondaryColumn.label}
            </div>
            <div
              className={classNames('', {
                'text-xl': isMobile,
                'text-3xl': !isMobile,
              })}
            >
              {info.secondaryColumn.value}
            </div>
            <div
              className={classNames(`${info.secondaryColumn.changeRaw < 0 ? 'text-ui-red' : 'text-ui-green'}`, {
                'text-xs': isMobile,
                'font-bold': !isMobile,
              })}
            >
              {info.secondaryColumn.changeValue ?? NBSP}
            </div>
          </div>
        )}
      </div>
      {info?.sparkLine && <SparkLine info={info.sparkLine} />}
    </ClickableCard>
  );
}

export { IndicatorCard };
